import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { contactForm } from "../../../services/authService";
import toast from "react-hot-toast";
import { emailRegex, phoneRegex } from "../../../utils/app-constant";
import { RightArrowIcon } from "../RightArrow";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters")
    .max(15, "Name cannot exceed 15 characters"),
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "Invalid email format"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(phoneRegex, "Phone number is not valid"),
  comment: Yup.string()
    .required("Comment is required")
    .min(3, "Comment must be at least 3 characters")
    .max(500, "Comment cannot exceed 500 characters"),
});

function Form() {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: any) => {
    const resData = await contactForm(data);
    if (resData?.status === "success") {
      toast.success(resData?.message ?? "Success");
      reset();
    }
  };

  return (
    <div className="sidebar-form">
      <h5 className="title">Enquire Now</h5>
      <form onSubmit={handleSubmit(onSubmit)} className="account__form">
        <div className="form-grp">
          <input
            type="text"
            id="fast-name"
            placeholder="Name"
            {...register("name")}
          />
          {errors.name && (
            <div className="text-danger">{errors.name.message}</div>
          )}
        </div>
        <div className="form-grp">
          <input
            type="email"
            id="email"
            placeholder="E - Mail"
            {...register("email")}
          />
          {errors.email && (
            <div className="text-danger">{errors.email.message}</div>
          )}
        </div>
        <div className="form-grp">
          <input
            type="tel"
            id="phone-no"
            placeholder="Phone"
            {...register("phone")}
          />
          {errors.phone && (
            <div className="text-danger">{errors.phone.message}</div>
          )}
        </div>
        <div className="form-grp">
          <textarea placeholder="Message" {...register("comment")} />
          {errors.comment && (
            <div className="text-danger">{errors.comment.message}</div>
          )}
        </div>
        <button
          type="submit"
          className="btn btn-two arrow-btn"
          style={{ margin: "0px 5px" }}
        >
          Submit Now
          {/* <img
            src="/assets/img/icons/right_arrow.svg"
            alt="img-text"
            className="injectable"
            width={16}
            height={14}
          /> */}
          <RightArrowIcon />
        </button>
      </form>
    </div>
  );
}

export default Form;
